import { DialogComponent } from './dialog/dialog.component';
import { ButtonComponent } from './button/button.component';
import { MapButtonComponent } from './map-button/map-button.component';
import { LegendaComponent } from './legenda/legenda.component';
import { LoaderComponent } from './loader/loader.component';
import { SsoHandlerComponent } from './sso-handler/sso-handler.component';
import { DialogUploadComponent } from './dialog-upload/dialog-upload.component';
import { ModalMultiBuildingComponent } from './modal-multi-building/modal-multi-building.component';
import { ModalMultiPointsComponent } from './modal-multi-points/modal-multi-points.component';
import { ModalSanitaScuoleComponent } from './modal-sanita-scuole/modal-sanita-scuole.component';

export const COMPONENTS = [
  DialogComponent,
  ButtonComponent,
  MapButtonComponent,
  LegendaComponent,
  LoaderComponent,
  SsoHandlerComponent,
  DialogUploadComponent,
  ModalMultiBuildingComponent,
  ModalMultiPointsComponent,
  ModalSanitaScuoleComponent
];
